const slots = new Map()
import { path } from 'ramda'

slots.set('title', ctx => ({
  key: 'title',
  component: 'InputComponent',
  validationKey: 'title',
  props: {
    label: ctx.labels.title,
    required: true,
  },
}))

slots.set('slug', ctx => ({
  key: 'slug',
  condition: !ctx.isNew,
  validationKey: 'slug',
  component: 'InputComponent',
  props: {
    label: ctx.labels.slug,
    required: true,
  },
}))
slots.set('publishedFrom', ctx => ({
  key: 'publishedFrom',
  component: 'InputComponent',
  props: {
    label: ctx.labels.publishedFrom,
  },
  slots: {
    default: [{ component: 'InputDate' }],
  },
}))
slots.set('publishing.relation', ctx => ({
  key: 'publishing.relation',
  dataField: 'publishing',
  component: 'Publishing',
  props: {
    reference: ctx.reference,
    id: ctx.id,
    source: ctx.schemaSource,
    references: ctx.schemaReferences,
  },
}))
slots.set('author', ctx => ({
  key: 'author',
  component: 'InputComponent',
  condition: !ctx.isNew,
  props: {
    label: ctx.labels.author,
    required: true,
  },
  slots: {
    default: [
      {
        component: 'UserSelect',
        props: {
          class: 'elder-input__element',
          title: ctx.$t('selectx', { x: ctx.labels.author.toLowerCase() }),
          items: ctx.fetchUsers,
          search: true,
        },
      },
    ],
  },
}))

slots.set('content', ctx => ({
  key: 'content',
  component: 'InputComponent',
  props: {
    label: ctx.labels.content,
  },
  slots: {
    default: [{ component: 'RichTextComponent' }],
  },
}))

slots.set('media.cover', ctx => ({
  key: 'media.cover',
  component: 'MediaComponent',
  dataField: 'cover',
  props: {
    enableFocusPoint: true,
    label: ctx.labels.cover,
    placement: 'inside',
    multiple: 'multiple',
    uploadOptions: { compression: 'gallery' },
    types: ctx.types,
    class: 'post-mutate__inputs-cover',
  },
  slots: {
    ['after-label']: [{ component: 'MediaRecommendation', props: { value: 'cover' } }],
  },
}))

export default slots
